import { render, staticRenderFns } from "./TrainingAutomationsList.vue?vue&type=template&id=5bb0832c&"
import script from "./TrainingAutomationsList.vue?vue&type=script&lang=js&"
export * from "./TrainingAutomationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports